// Los enlaces de los correos abren herramientas existentes. Nunca activan
// una prueba, una compra ni una generación de IA por visitar una dirección.
export const ACCIONES_BIENVENIDA = Object.freeze({
  estudiante: { texto: 'Abrir Tu PAE', destino: 'pae' },
  enfermero: { texto: 'Abrir MiPAE en turno', destino: 'turno' },
  tens: { texto: 'Abrir mi turno TENS', destino: 'turno' },
  general: { texto: 'Elegir mi experiencia', destino: 'perfil' },
});

export function accionBienvenida(rol) {
  const accion = ACCIONES_BIENVENIDA[rol] || ACCIONES_BIENVENIDA.general;
  return { ...accion, url: `https://mipae.cl/?inicio=${accion.destino}` };
}

export function destinoBienvenida(pedido, perfil) {
  if (!perfil?.perfil_completado) return null;
  if (pedido === 'perfil') return 'perfil';
  if (pedido === 'pae' && perfil.rol === 'estudiante') return 'tu-pae';
  if (pedido === 'turno' && ['enfermero', 'tens'].includes(perfil.rol)) return 'registro-turno';
  // Un enlace reenviado no cambia de experiencia ni concede permisos.
  return null;
}
